module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("CRM管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("销售话术库")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 85,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "场景"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryParam.scene),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "scene", $$v)
      },
      expression: "queryParam.scene"
    }
  }, _vm._l((_vm.sceneOptions), function(opt) {
    return _c('Option', {
      key: opt.value,
      attrs: {
        "value": opt.value
      }
    }, [_vm._v(_vm._s(opt.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "全部"
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("候选")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("已发布")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "话术"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "关键字"
    },
    model: {
      value: (_vm.queryParam.phrase),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "phrase", $$v)
      },
      expression: "queryParam.phrase"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/callScript/page-list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.form.id ? '编辑话术' : '新增话术',
      "width": "560"
    },
    model: {
      value: (_vm.editVisible),
      callback: function($$v) {
        _vm.editVisible = $$v
      },
      expression: "editVisible"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "场景"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.scene),
      callback: function($$v) {
        _vm.$set(_vm.form, "scene", $$v)
      },
      expression: "form.scene"
    }
  }, _vm._l((_vm.sceneOptions), function(opt) {
    return _c('Option', {
      key: opt.value,
      attrs: {
        "value": opt.value
      }
    }, [_vm._v(_vm._s(opt.label))])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "话术"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "给销售复用的标准句"
    },
    model: {
      value: (_vm.form.phrase),
      callback: function($$v) {
        _vm.$set(_vm.form, "phrase", $$v)
      },
      expression: "form.phrase"
    }
  })], 1), _vm._v(" "), (_vm.form.id) ? _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("候选")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("已发布")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("停用")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-281c705d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/crm/CallScript.vue
// module id = 1695
// module chunks = 8